import { columnTextField } from "utils/tables-utils";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { IconButton } from "@material-ui/core";
import BugReportIcon from "@mui/icons-material/BugReport";
import ArticleIcon from "@mui/icons-material/Article";

export default function TableProcessamentoCatalogo({ data, setLogDetail }) {
  const columnModel = [
    columnTextField(
      {
        dataField: "createdAt",
        text: "Criado em",
        align: "center",
      },
      false
    ),
    columnTextField(
      {
        dataField: "totalLines",
        text: "Tot. de linhas",
        align: "center",
      },
      false
    ),
    columnTextField(
      {
        dataField: "processedLines",
        text: "Linhas Processadas",
        align: "center",
      },
      false
    ),
    columnTextField(
      {
        dataField: "unprocessedLines",
        text: "Linhas Não Processadas",
        align: "center",
      },
      false
    ),
    columnTextField(
      {
        dataField: "status",
        text: "Status",
        align: "center",
      },
      false
    ),
    columnTextField(
      {
        dataField: "log",
        text: "Log",
        align: "center",
        formatter: (_, row) => {
          return (
            <IconButton onClick={() => setLogDetail(row)}>
              {row.status === "ERRO" ? <BugReportIcon /> : <ArticleIcon />}
            </IconButton>
          );
        },
      },
      false
    ),
  ];

  return (
    <>
      <ToolkitTable
        dataTable={data}
        searched={Boolean(data)}
        keyField="id"
        columnModel={columnModel}
        headerTitle="Lista de processamento"
        notFoundTitle="Não há itens sendo processados no momento."
      />
    </>
  );
}
